const platforms = [
  {
    name: 'MetaTrader 4',
    type: 'Platformă de Trading',
    desc: 'Cea mai populară platformă de trading din lume. Suportă expert advisors (roboți) și analiză tehnică avansată.',
    features: ['Expert Advisors', 'Grafice avansate', 'Indicatori personalizați', 'Backtesting'],
    image: 'https://public.readdy.ai/ai/img_res/e14f486d923f7955997cc8dc3b105807.jpg',
    badge: 'Popular',
    badgeColor: '#4ecdc4',
  },
  {
    name: 'TradingView',
    type: 'Analiză & Grafice',
    desc: 'Platformă web profesionistă pentru analiză tehnică și socializare cu alți traderi. Perfectă pentru studiu și practică.',
    features: ['Grafice interactive', 'Idei comunitate', '100+ indicatori', 'Paper Trading'],
    image: 'https://readdy.ai/api/search-image?query=TradingView%20platform%20interface%20financial%20charts%20technical%20analysis%20tools%20indicators%20clean%20dark%20theme%20professional%20trading%20screen%20elegant%20modern%20web%20app%20design&width=600&height=400&seq=platform02&orientation=landscape',
    badge: 'Gratuit',
    badgeColor: '#0f1419',
  },
  {
    name: 'Calculator Forex',
    type: 'Instrument de Calcul',
    desc: 'Calculează rapid valorile de pip, dimensiunile de lot, marja necesară și profitul/pierderea potențiale înainte de a deschide o tranzacție.',
    features: ['Calcul pip', 'Dimensiune lot', 'Margin calculator', 'Risk/Reward'],
    image: 'https://readdy.ai/api/search-image?query=forex%20calculator%20financial%20calculation%20risk%20management%20tool%20numbers%20spreadsheet%20trading%20math%20clean%20minimal%20warm%20background%20teal%20elements%20professional%20finance%20app&width=600&height=400&seq=platform03&orientation=landscape',
    badge: 'Esențial',
    badgeColor: '#ffb5a7',
  },
  {
    name: 'Calendar Economic',
    type: 'Știri & Evenimente',
    desc: 'Urmărește evenimentele economice majore: rapoarte NFP, decizii ale băncilor centrale, date despre inflație — toate influențează piața Forex.',
    features: ['Evenimente live', 'Impact estimat', 'Notificări', 'Istoricul datelor'],
    image: 'https://readdy.ai/api/search-image?query=economic%20calendar%20forex%20financial%20news%20events%20calendar%20schedule%20market%20news%20clean%20minimal%20warm%20cream%20background%20teal%20accents%20professional%20finance%20news%20feed&width=600&height=400&seq=platform04&orientation=landscape',
    badge: 'Recomandat',
    badgeColor: '#4ecdc4',
  },
];

export default function Instrumente() {
  return (
    <section id="instrumente" className="py-24" style={{ background: '#0f1419' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 mb-16">
          <div>
            <span
              className="inline-flex items-center border border-white/20 text-white/60 text-xs uppercase tracking-widest px-4 py-1 rounded-full mb-4"
            >
              03 — Instrumente și Platforme
            </span>
            <h2
              className="text-4xl md:text-5xl font-bold text-white leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Platforme și Unelte
              <br />
              <span style={{ color: '#4ecdc4' }}>pentru Succes</span> în Trading
            </h2>
          </div>
          <p className="text-gray-400 max-w-md text-base leading-relaxed">
            Alegerea instrumentelor potrivite face diferența între un trader pregătit și unul nepregătit.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {platforms.map((p, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden group cursor-default transition-transform duration-300 hover:-translate-y-2"
              style={{ background: '#1a1f26' }}
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, transparent 40%, rgba(26,31,38,0.9))' }}></div>
                {/* Badge */}
                <div
                  className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-bold"
                  style={{ background: p.badgeColor, color: p.badgeColor === '#ffb5a7' ? '#0f1419' : '#fff' }}
                >
                  {p.badge}
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1">{p.type}</p>
                <h3 className="text-lg font-bold text-white mb-2">{p.name}</h3>
                <p className="text-sm text-gray-400 leading-relaxed mb-4">{p.desc}</p>

                {/* Features */}
                <ul className="space-y-1">
                  {p.features.map((f, fi) => (
                    <li key={fi} className="flex items-center gap-2 text-xs text-gray-400">
                      <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#4ecdc4' }}></span>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div
          className="mt-16 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6"
          style={{ background: 'rgba(78,205,196,0.08)', border: '1px solid rgba(78,205,196,0.2)' }}
        >
          <div>
            <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Cont Demo — Practică fără risc
            </h3>
            <p className="text-gray-400 text-sm">
              Toți brokerii serioși oferă conturi demo cu bani virtuali. Practică timp de 3-6 luni înainte de a folosi bani reali.
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 text-white text-sm">
              <i className="ri-checkbox-circle-line" style={{ color: '#4ecdc4' }}></i>
              Fără risc
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 text-white text-sm">
              <i className="ri-checkbox-circle-line" style={{ color: '#4ecdc4' }}></i>
              Bani virtuali
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
